import axios from 'axios'
import { API_ADMIN } from '@/utils/constants/Api'
import { ServiceStatusInformationModel } from '../models/ServiceStatusInformationModel';
import { ServiceStatusInformationByStoreModel } from '../models/ServiceStatusInformationByStoreModel';
import { orderBy } from 'lodash';
import { ChannelStatusSynchronizationModel } from '../models/ChannelStatusSynchronizationModel';

export default {
    getServiceStatusInformation(): Promise<ServiceStatusInformationModel[]> {
        return axios.get(`${API_ADMIN}services/status_information`)
            .then(({ data }) => {
                return data.map((d: ServiceStatusInformationModel) => {
                    return new ServiceStatusInformationModel(d);
                });
            });
    },
    confirmReadStatus(idStatus: number): Promise<ServiceStatusInformationModel[]> {
        return axios.put(`${API_ADMIN}services/status_information/${idStatus}/confirm-read`)
            .then(({ data }) => {
                return data.map((d: ServiceStatusInformationModel) => {
                    return new ServiceStatusInformationModel(d);
                });
            });
    },
    getServiceStatusInformationByStore(): Promise<ServiceStatusInformationModel[]> {
        return axios.get(`${API_ADMIN}services/stores/status_information`)
            .then(({ data }) => {
                return orderBy(data.map((d: ServiceStatusInformationByStoreModel) => {
                    return new ServiceStatusInformationByStoreModel(d);
                }), ['name'], ['asc']);
            });
    },
    getChannelsStatusSynchronization(idChannel: number): Promise<ChannelStatusSynchronizationModel[]> {
        return axios.get(`${API_ADMIN}services/channels/status_synchronization`, {
            params: idChannel ? { idChannel } : undefined
        })
            .then(({ data }) => {
                return data.map((c: ChannelStatusSynchronizationModel) => {
                    return new ChannelStatusSynchronizationModel(c);
                });
            });
    },
    async getChannelStatusSynchronizationByChannelId(idChannel: number): Promise<ChannelStatusSynchronizationModel> {
        return this.getChannelsStatusSynchronization(idChannel)
            .then((channelStatusList: ChannelStatusSynchronizationModel[]) => {
                return channelStatusList.find((chStatus) => String(chStatus.id) === String(idChannel)) as ChannelStatusSynchronizationModel
            });
    },
}

